import { ThemeParser } from '../../../core/theme';
import { overrideIfUndefined } from '../../../util/data';
import { normalizeToArray } from '../../../util/utils';
import { judgeIsDynamicBar } from '../series/dynamicBar';

export function animationThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  const series = normalizeToArray(option.series);
  if (judgeIsDynamicBar(series)) {
    const DEFAULT_UPDATE_FREQUENCY = 1000;
    option.animationDuration = overrideIfUndefined(
      option.animationDuration,
      DEFAULT_UPDATE_FREQUENCY
    );
    option.animationDurationUpdate = overrideIfUndefined(
      option.animationDurationUpdate,
      DEFAULT_UPDATE_FREQUENCY
    );
    option.animationEasing = overrideIfUndefined(option.animationEasing, 'linear');
    option.animationEasingUpdate = overrideIfUndefined(option.animationEasingUpdate, 'linear');
  }
}
